import { StorageService } from "core/services/storage.service";
import { PERMISSIONS } from "shared/enums/permissions.enum";

export abstract class AuthAwareComponent {
  protected readonly PERMISSIONS = PERMISSIONS;

  constructor(protected storageService: StorageService) {}

  protected hasPermission(permission: PERMISSIONS): boolean {
    return this.storageService.hasPermission(permission);
  }
}